var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1502 110.52L115 60.65C115.142 60.507 115.311 60.3935 115.498 60.3161C115.684 60.2386 115.883 60.1987 116.085 60.1987C116.287 60.1987 116.486 60.2386 116.673 60.3161C116.859 60.3935 117.028 60.507 117.17 60.65L137.44 80.92C137.582 81.063 137.751 81.1765 137.938 81.254C138.124 81.3314 138.323 81.3713 138.525 81.3713C138.727 81.3713 138.926 81.3314 139.113 81.254C139.299 81.1765 139.468 81.063 139.61 80.92L155.05 65.5C155.193 65.3578 155.307 65.1888 155.384 65.0026C155.462 64.8164 155.501 64.6167 155.501 64.415C155.501 64.2133 155.462 64.0137 155.384 63.8275C155.307 63.6413 155.193 63.4722 155.05 63.33L117.2 25.48C117.058 25.337 116.889 25.2235 116.703 25.1461C116.516 25.0686 116.317 25.0287 116.115 25.0287C115.913 25.0287 115.714 25.0686 115.528 25.1461C115.341 25.2235 115.172 25.337 115.03 25.48L47.5602 92.94C47.4171 93.0822 47.3036 93.2512 47.2262 93.4375C47.1488 93.6237 47.1089 93.8233 47.1089 94.025C47.1089 94.2267 47.1488 94.4264 47.2262 94.6126C47.3036 94.7988 47.4171 94.9678 47.5602 95.11L63.0001 110.53C63.1423 110.673 63.3114 110.787 63.4976 110.864C63.6838 110.941 63.8835 110.981 64.0851 110.981C64.2868 110.981 64.4865 110.941 64.6727 110.864C64.8589 110.787 65.028 110.673 65.1701 110.53L65.1502 110.52Z",
    fill: "url(#paint0_linear_31_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.48 85.5L107.94 18C108.083 17.8578 108.197 17.6887 108.274 17.5025C108.351 17.3163 108.391 17.1166 108.391 16.915C108.391 16.7133 108.351 16.5136 108.274 16.3274C108.197 16.1412 108.083 15.9722 107.94 15.83L92.52 0.449981C92.3778 0.306968 92.2088 0.193476 92.0226 0.116031C91.8364 0.0385869 91.6367 -0.00128174 91.435 -0.00128174C91.2334 -0.00128174 91.0337 0.0385869 90.8475 0.116031C90.6613 0.193476 90.4922 0.306968 90.35 0.449981L40.48 50.32C40.3379 50.463 40.1688 50.5765 39.9826 50.6539C39.7964 50.7314 39.5967 50.7712 39.395 50.7712C39.1934 50.7712 38.9937 50.7314 38.8075 50.6539C38.6213 50.5765 38.4522 50.463 38.31 50.32L18 30.05C17.8579 29.907 17.6888 29.7935 17.5026 29.716C17.3164 29.6386 17.1167 29.5987 16.915 29.5987C16.7134 29.5987 16.5137 29.6386 16.3275 29.716C16.1413 29.7935 15.9722 29.907 15.83 30.05L0.450042 45.47C0.307029 45.6122 0.193537 45.7812 0.116092 45.9674C0.038648 46.1536 -0.0012207 46.3533 -0.0012207 46.555C-0.0012207 46.7566 0.038648 46.9563 0.116092 47.1425C0.193537 47.3287 0.307029 47.4978 0.450042 47.64L38.3 85.49C38.4422 85.633 38.6113 85.7465 38.7975 85.8239C38.9837 85.9014 39.1834 85.9412 39.385 85.9412C39.5867 85.9412 39.7864 85.9014 39.9726 85.8239C40.1588 85.7465 40.3279 85.633 40.47 85.49L40.48 85.5Z",
    fill: "url(#paint1_linear_31_110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_110",
    x1: 115,
    y1: 43.0001,
    x2: 19.9998,
    y2: 136.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F4244",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_110",
    x1: 134,
    y1: -27,
    x2: 39.5005,
    y2: 69.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#091747",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091747"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.5,
    height: 110.98,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShape);
export default __webpack_public_path__ + "static/media/logo-shape.5933516d49eea8b57c06cbb5e4945a9a.svg";
export { ForwardRef as ReactComponent };